<template>
    <span>
        <button class="btn-link"
                @click="viewItem()">
            <slot name="modal-link"></slot>
        </button>
        <!-- added close directive in order to reset the modal state -->
        <modal :show.sync="modals.classic" @close="resetModal" headerClasses="justify-content-center">
         <center>
    <div
      v-if="this.bankingOffice != null"
      class="card card-body agatrs-card-style"
    >
      <div class="col-md-12">
        <Header :pageTitle="pageTitle" class="card-container"></Header>
          <div class="col-md-6">
            <label>Country</label>
            <v-select
              data-vv-as="Country"
              :class="errors.has('CountryDropdown') ? 'has-danger' : 'no'"
              :error="getError('CountryDropdown')"
              v-validate="'required'"
              v-model="bankingOffice['countryId']"
              name="CountryDropdown"
              :reduce="(item) => item.countryId"
              label="name"
              :options="countriesOptions"
              placeholder="Please select a country."
            />
            <span v-show="errors.has('CountryDropdown')" class="error">
              {{ errors.first("CountryDropdown") }}</span
            >
          </div>
          <div class="col-md-6">
            <label>Bank Name</label>
            <base-input
              data-vv-as="Bank Name"
              v-validate="'required'"
              v-model="bankingOffice['bankName']"
              name="bankName"
              placeholder="Please enter bank name."
              :error="getError('bankName')"
            />
          </div>
          <div class="col-md-6">
            <label>Bank Address</label>
            <base-input
              data-vv-as="Bank Address"
              v-validate="'required'"
              v-model="bankingOffice['bankAddress']"
              name="bankAddress"
              placeholder="Please enter bank address."
              :error="getError('bankAddress')"
            />
          </div>
          <div class="col-md-6">
            <label>Account Name/Number</label>
            <base-input
              data-vv-as="Account Name/Number"
              v-validate="'required'"
              v-model="bankingOffice['accountName']"
              name="accountNumber"
              placeholder="Please enter bank account number."
              :error="getError('accountNumber')"
            />
          </div>
          <div class="col-md-6 ">
            <label>International Bank Account Number (IBAN)</label>
            <base-input
              v-model="bankingOffice['iban']"
              name="BankIBAN"
              placeholder="Please enter International Bank Account Number (IBAN)."
            />
          </div>
          <div class="col-md-6">
            <label>SWIFT / ABA</label>
            <base-input
              v-model="bankingOffice['swift']"
              name="BankSWIFT"
              placeholder="Please enter SWIFT / ABA."
            />
          </div>
         <div class="row justify-content-center text-center ">
          <div >
            <base-button
              @click="returnToEditBankingOfficesDashboard()"
              class="btn btn-primary"
              v-b-popover.hover.bottom="
                'Navigate back to edit banking offices dashboard.'
              "
            >
              <i class="tim-icons icon-double-left center-btn-content"></i> Return to table
            </base-button>
          </div>
          <div>
            <base-button
              @click="saveBankingOffice()"
              type="primary"
              v-b-popover.hover.bottom="'Save changes.'"
            >
              <i class="tim-icons icon-bank center-btn-content"></i> Save Changes
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </center>
        </modal>
    </span>
</template>

<script>
import Header from "@/components/App/Header.vue";
import axios from "@/axios";
import {  Modal } from "@/components";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EditBankingOffice",
  components: {
    Header,
    Modal
  },
  data() {
    return {
      bankingOffice: null,
       modals: {
                    classic: false,
                },
    };
  },
    props: {  
    id: {
      default: 0
    },
        },
  computed: {
    ...mapGetters({
      countriesOptions: "countries/allCountries",
      paginatedBankingOffices: "bankingOffice/paginatedBankingOffices",
    }),
    pageTitle() {
      return `Edit Banking Office`;
    },
  },
  async mounted() {
    await this.getBankingOffice();
    this.errors.clear();
    this.getAllCountries();
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries", 
      getPaginatedBankingOffices: "bankingOffice/getPaginatedBankingOffices",
    }),
     async viewItem() {

           await this.getBankingOffice();
    this.errors.clear();
    this.getAllCountries().then(()=>{
             this.modals.classic = true;
        });
               
            },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    returnToEditBankingOfficesDashboard() {
      this.modals.classic = false
    },
    async getBankingOffice() {
      // if bankingoffices are in the store, no need to call the api again to fetch one.
      this.bankingOffice = this.paginatedBankingOffices.find(
        (d) => d.id == this.id
      );

      // if bankingoffice is null => user refresh the edit page
      if (this.bankingOffice == null || this.bankingOffice == undefined) {
        let ret = await this.getBankingOfficeFromVue();
        this.bankingOffice = ret.data;
      }
    },
    async getBankingOfficeFromVue() {
      return await axios.get(`api/adminbankingoffice/${this.id}`);
    },
    async saveBankingOffice() {
      let ctx = this;
      let result = await this.$validator.validateAll();
      if (result) {
        await axios
          .post("api/adminbankingoffice", this.bankingOffice)
          .then(() => {
            this.modals.classic = false
          });
      }
    },
  },
};
</script>

<style scoped>
.center-btn-content {
 height:18px; margin-right: 3px
}
</style>